import PropTypes from 'prop-types'
import { Box, Checkbox, HStack, Text, VStack } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { numberFormat } from '../../utils/formats/formats'
import Selector from '../Selector/Selector'
import { REPOSITORY } from '../../api/repository/Repository'

export default function DiscountConfirmation({
  ammount,
  accounts,
  costCenter,
  notify,
  handleNotify,
  handleAssign,
  assign,
}) {
  const { sCentroCosto } = REPOSITORY.local.company.getCompanyData()
  const formattedCostCenter = useMemo(() => {
    if (sCentroCosto) {
      const actualCostCenter = sCentroCosto
      actualCostCenter.pop()
      return sCentroCosto
    }
  }, [sCentroCosto])
  return (
    <VStack w="100%">
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text textAlign="left">Monto a recargar</Text>
        </Box>
        <Box>
          <Text textAlign="left">{numberFormat(ammount, 'currency')}</Text>
        </Box>
      </HStack>
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text textAlign="left">Cantidad de cuentas</Text>
        </Box>
        <Box>
          <Text textAlign="left">{accounts}</Text>
        </Box>
      </HStack>
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text textAlign="left">Asignar a centro de costo:</Text>
        </Box>
        <Box>
          <Text textAlign="left">{costCenter}</Text>
          <Selector
            onChange={handleAssign}
            options={formattedCostCenter}
            defaultValue={
              formattedCostCenter.find((el) => el.id === assign) || null
            }
            placeholder="Centros de costos de origen"
            isClearable
          />
        </Box>
      </HStack>
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text textAlign="left">¿Notificar a colaboradores?</Text>
        </Box>
        <Box>
          <Checkbox isChecked={notify} onChange={handleNotify} />
          <Text textAlign="left">{notify}</Text>
        </Box>
      </HStack>
    </VStack>
  )
}

DiscountConfirmation.propTypes = {
  accounts: PropTypes.number,
  ammount: PropTypes.string,
  assign: PropTypes.string,
  branchOffice: PropTypes.string,
  costCenter: PropTypes.string,
  handleAssign: PropTypes.func,
  handleNotify: PropTypes.func,
  notify: PropTypes.bool,
}
